<script lang="ts">
  import { editor } from '../store/editor.svelte';
  import Icon, { type IconName } from './Icon.svelte';
  import type { ToolId } from '../domain/types';

  interface Props {
    /** true — плавающая горизонтальная панель (как в Figma); false — вертикальная. */
    floating?: boolean;
  }
  let { floating = false }: Props = $props();

  interface ToolDef {
    id: ToolId;
    icon: IconName;
    label: string;
    hotkey: string;
  }

  const tools: ToolDef[] = [
    { id: 'select', icon: 'cursor', label: 'Выделение', hotkey: 'V' },
    { id: 'arrow', icon: 'arrow', label: 'Стрелка', hotkey: 'A' },
    { id: 'number', icon: 'number', label: 'Нумерация', hotkey: 'N' },
    { id: 'rect', icon: 'square', label: 'Прямоугольник / Маскировка', hotkey: 'R' },
    { id: 'pencil', icon: 'pencil', label: 'Карандаш', hotkey: 'P' },
    { id: 'text', icon: 'text', label: 'Текст', hotkey: 'T' },
  ];

  // Лёгкое разделение между группами инструментов.
  const groupBreaks = new Set<string>(['arrow', 'rect', 'text']);
</script>

<!-- Плавающая горизонтальная панель -->
<div
  class="panel rounded-2xl shadow-xl flex items-center gap-1 p-1.5"
>
  {#each tools as t, i (t.id)}
    {#if i > 0 && groupBreaks.has(t.id)}
      <div class="w-px h-7 bg-edge mx-0.5"></div>
    {/if}
    <button
      class="btn-icon {editor.activeTool === t.id ? 'active' : ''}"
      title={`${t.label} (${t.hotkey})`}
      aria-label={t.label}
      aria-pressed={editor.activeTool === t.id}
      onclick={() => editor.setTool(t.id)}
    >
      <Icon name={t.icon} />
    </button>
  {/each}
</div>
